import { useFormik } from 'formik';
import * as Yup from 'yup';
import {
    getErrorMessage,
    openNotification,
    useQueryParams,
    validatePassword
} from '../utils/helper';
import { useNavigate } from 'react-router-dom';
import Button from '../components/button/Button';
import Input from '../components/input/Input';
import { mutateConfig } from '../api/queryBase';
import { AxiosError } from 'axios';
import { useEffect } from 'react';

const ResetPassword = () => {
    const navigate = useNavigate();
    const query = useQueryParams();
    const email = query.get('email');
    const resetCode = query.get('resetCode');

    const mutation = mutateConfig();
    const { mutate, isLoading } = mutation({
        url: `/auth/password/reset`
    });

    const validationSchema = Yup.object().shape({
        password: Yup.string()
            .required('Password is required')
            .test(
                'is-strong-password',
                'Password must be at least 8 characters long and include at least one uppercase letter, one lowercase letter, one number, and one special character.',
                (value) => validatePassword(value || '')
            )
    });

    useEffect(() => {
        if (!email || !resetCode) {
            navigate('/login');
        }
    }, [email, resetCode]);

    const formik = useFormik({
        initialValues: {
            password: ''
        },
        validationSchema,
        onSubmit: (values) => {
            mutate(
                {
                    password: values.password,
                    email,
                    resetCode
                },
                {
                    onSettled: (res, error: AxiosError | undefined | any) => {
                        if (error) {
                            openNotification(
                                'error',
                                getErrorMessage(error) ||
                                    'Forgot password, Something went wrong'
                            );
                        } else {
                            openNotification(
                                'success',
                                'Password reset successful.'
                            );
                            navigate('/login');
                        }
                    }
                }
            );
        }
    });

    return (
        <div>
            <div className='bg-appcolorwhite py-[2.7rem] lg:py-[2.5rem] lg:px-[2.6rem] px-[1.6rem] mb-[1.75rem] rounded-[3px]'>
                <form
                    autoComplete='off'
                    onSubmit={formik.handleSubmit}
                    noValidate
                >
                    <div className='flex flex-col gap-4 lg:gap-[4]'>
                        <Input
                            label='New Password'
                            type='password'
                            required
                            id='signin-password'
                            name='password'
                            value={formik.values.password}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            errorMessage={
                                formik.touched.password &&
                                formik.errors.password
                                    ? formik.errors.password
                                    : ''
                            }
                        />
                    </div>

                    <div className='mt-4'>
                        <Button
                            isLoading={isLoading}
                            type='submit'
                            className='w-full'
                            disabled={isLoading}
                            text='Continue'
                        />
                    </div>
                </form>
            </div>
        </div>
    );
};

export default ResetPassword;
